import * as Inventory from '.';
import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import {
  getGemsToEnergyExchangeRates,
  getGemsToPointsExchangeRates,
} from './inventory.getters';

export const inventoryActions = createActions({
  /**
   * Consume gems and give points by provided exchange rate
   */
  exchangeGemsToPoints: action((state, amount: number, api) => {
    // Make sure that we have this rate on server
    // Without this check clint could fake data and get point for free
    const rates = getGemsToPointsExchangeRates();
    const rate = rates.find(({ items }) => items === amount);
    if (!rate) throw new Error('Exchange rate not found');

    // How much point we're going to give to user?
    // Base item value + bonus
    const reward = rate.items + rate.bonus;

    // How many gems will be consumed
    const consume = rate.premium;

    // How many gems user have?
    const gems = Inventory.getters.getGems(state);

    // Is this enough to do exchange?
    if (gems < consume) throw new Error('Not enough gems for exchange');

    // Do exchange

    // Add points
    Inventory.modifiers.addPoints(
      state,
      reward,
      {
        feature: 'currency_exchange',
        $subFeature: 'bPoints',
      },
      api,
    );

    // Consume gems
    Inventory.modifiers.consumeGems(
      state,
      consume,
      {
        feature: 'currency_exchange',
        $subFeature: 'bPoints',
      },
      api,
    );
  }),

  /**
   * Consume gems and give energy by provided exchange rate
   */
  exchangeGemsToEnergy: action((state, amount: number, api) => {
    // Make sure that we have this rate on server
    // Without this check clint could fake data and get point for free
    const rates = getGemsToEnergyExchangeRates(state);
    const rate = rates.find(({ items }) => items === amount);
    if (!rate) throw new Error('Exchange rate not found');

    // How much energy we're going to give to user?
    // Base item value + bonus
    const reward = rate.items + rate.bonus;

    // How many gems will be consumed
    const consume = rate.premium;

    // How many gems user have?
    const gems = Inventory.getters.getGems(state);

    // Is this enough to do exchange?
    if (gems < consume) throw new Error('Not enough gems for exchange');

    // Do exchange
    const now = api.date.now();

    // Add energy
    Inventory.modifiers.addEnergy(
      state,
      reward,
      now,
      {
        feature: 'currency_exchange',
        $subFeature: 'energy',
      },
      api,
    );

    // Consume gems
    Inventory.modifiers.consumeGems(
      state,
      consume,
      {
        feature: 'currency_exchange',
        $subFeature: 'energy',
      },
      api,
    );
  }),
});
